module.exports = __webpack_public_path__ + "static/media/Email.4fcd624c.png";


//////////////////
// WEBPACK FOOTER
// ./src/guitar/Email.png
// module id = 31
// module chunks = 0